import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { getOrdering } from '@/utils/get-ordering'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type SchoolYearParams } from '../queries/useSchoolYears'

type Params = DownloadParams & SchoolYearParams

const useSchoolYearsDownload = (schoolYearParams: Params) =>
  useDownload({
    fileName: 'school_years',
    requestParams: schoolYearParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: Params) =>
      httpService.panel.panelPeriodsYearsList(
        {
          status:
            params.status === 'past' ? ['archived'] : ['active', 'future'],
          search: params.search,
          ordering: params.order
            ? getOrdering(params)
            : params.status === 'past'
              ? '-start_date'
              : 'start_date',
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useSchoolYearsDownload
